import React from 'react'
import { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import ChangePriceBillItemForm from './ChangePriceBillItemForm'
import { Tooltip } from '@mui/material'
import { currencyText } from '../../../../../helpers/unitMeasure/UnitMeasureHelper'

const ChangePriceBillItemButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <div className='supplyCounts cursorP'
            onClick={e => setOpen(true)}
        >
            <p className='supplyCounts__green'>
                <Tooltip title='За одиницю'>
                    {supplyBillItem.priceOne ? supplyBillItem.priceOne : 0}
                </Tooltip>
            </p>
            <span>/</span>
            <p className='supplyCounts__yellow'>
                <Tooltip title='Загалом'>
                    {supplyBillItem.priceGeneral ? supplyBillItem.priceGeneral : 0}
                </Tooltip>
            </p>
            <p>
                {
                    // unitMeasureShortText[supplyOrderItem.unitMeasure]
                    currencyText[supplyBillItem.currency]
                }
            </p>
        </div>
        <div>
            {/* <p> */}
                {`(з ПВД ${
                    supplyBillItem.pdvType === 'withoutPdv' && supplyBillItem.priceWithPdv ?
                        `${supplyBillItem.priceWithPdv.one}/${supplyBillItem.priceWithPdv.general}`
                    : ''
                })`}
            {/* </p> */}
        </div>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагувати вартість позиції'}
            disableClickOutside={true}
            content={
                <ChangePriceBillItemForm
                    // supplyOrderId={supplyOrderId}
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangePriceBillItemButton